module.exports = __webpack_public_path__ + "images/fa-cfa-what-you-get-4.webp";